import { createAsyncActions } from '@wahaaabello/redux-async-actions';

const [, fetchInvestmentsSuccess, fetchInvestmentsFailure] = createAsyncActions(
  'FETCH_INVESTMENTS'
);

const [
  fetchInvestmentRequest,
  fetchInvestmentSuccess,
  fetchInvestmentFailure
] = createAsyncActions('FETCH_INVESTMENT');

const [
  fetchInvestmentPageRequest,
  fetchInvestmentPageSuccess,
  fetchInvestmentPageFailure
] = createAsyncActions('FETCH_INVESTMENT_PAGE');

const [fetchMyInvestmentsRequest] = createAsyncActions('FETCH_MY_INVESTMENTS');

const [fetchMyClosedInvestmentsRequest] = createAsyncActions(
  'FETCH_MY_CLOSED_INVESTMENTS'
);

const [fetchInvestmentsByCategoryRequest] = createAsyncActions(
  'FETCH_INVESTMENTS_BY_CATEGORY'
);

const [searchInvestmentsRequest] = createAsyncActions('SEARCH_INVESTMENTS');

const investmentsActions = {
  fetchMyInvestmentsRequest,
  fetchInvestmentsByCategoryRequest,
  searchInvestmentsRequest,
  fetchMyClosedInvestmentsRequest,
  fetchInvestmentsSuccess,
  fetchInvestmentsFailure,
  fetchInvestmentRequest,
  fetchInvestmentSuccess,
  fetchInvestmentFailure,
  fetchInvestmentPageRequest,
  fetchInvestmentPageSuccess,
  fetchInvestmentPageFailure
};

export default investmentsActions;
